'use strict';

var React = require('react'),
    _ = require('underscore'),
    LightboxOverlay = require('./LightboxOverlay'),
    Fade = require('./Fade'),
    FadingCalculatorMixin = require('../mixins/FadingCalculatorMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    LightboxMixin = require('../mixins/LightboxMixin'),
    StampScrollMixin = require('../mixins/StampScrollMixin'),
    BackColorMixin = require('../mixins/BackColorMixin'),
    UserStore = require('../stores/UserStore'),
    ZineStore = require('../stores/ZineStore'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    assign = require('react/lib/Object.assign'),
    shallowEqual = require('react/lib/shallowEqual'),
    SectionTypes = require('../constants/SectionTypes'),
    MediaTypes = require('../constants/MediaTypes'),
    MediaSources = require('../constants/MediaSources'),
    GalleryLayouts = require('../constants/GalleryLayouts'),
    { PropTypes } = React;

var LightboxSections = [
  SectionTypes.GALLERY,
  SectionTypes.POSTER,
  SectionTypes.COVER
];

var SectionComponents = {};
SectionComponents[SectionTypes.COVER] = require('./Cover');
SectionComponents[SectionTypes.POSTER] = require('./Poster');
SectionComponents[`${SectionTypes.GALLERY}:${GalleryLayouts.LIST}`] = require('./ListGallery');
SectionComponents[`${SectionTypes.GALLERY}:${GalleryLayouts.GRID}`] = require('./GridGallery');
SectionComponents[SectionTypes.TEXT] = require('./Text');
SectionComponents[SectionTypes.INFO] = require('./InfoPanel');
SectionComponents[`${SectionTypes.MEDIA}:${MediaTypes.AUDIO_TRACK}:${MediaSources.SOUNDCLOUD}`] = require('./AudioTrack');
SectionComponents[`${SectionTypes.MEDIA}:${MediaTypes.AUDIO_PLAYLIST}:${MediaSources.SOUNDCLOUD}`] = require('./AudioPlayList');
SectionComponents[`${SectionTypes.MEDIA}:${MediaTypes.VIDEO}:${MediaSources.VIMEO}`] = require('./Video');
SectionComponents[SectionTypes.BUY_IN_ITUNES] = require('./BuyInItunes');

var Stamp = React.createClass({
  mixins: [
    createStoreMixin(UserStore, ZineStore),
    PureRenderMixin, FadingCalculatorMixin, LightboxMixin, BackColorMixin, StampScrollMixin
  ],

  propTypes: {
    stamp: PropTypes.object.isRequired,
    nextUp: PropTypes.element,
    primaryZine: PropTypes.object,
    isInViewer: PropTypes.bool,
    onInfoPanelOffsetTopChange: PropTypes.func,
    showFeedback: PropTypes.bool,
    disableInfoPanel: PropTypes.bool
  },

  getStateFromStores(props) {
    var { stamp, primaryZine, isInViewer, disableInfoPanel } = props,
        user = UserStore.get(stamp.user),
        zines = (isInViewer ? stamp.zines : []).map(ZineStore.get),
        contentSections = stamp.content && stamp.content.sections.slice(1),
        handleInfoPanelOffsetTopChange = this.props.onInfoPanelOffsetTopChange,
        isLoading = !contentSections,
        sections;

    sections = [{
      key: stamp.id + '-cover',
      type: SectionTypes.COVER,
      stamp: stamp,
      isLoading: isLoading,
      primaryZine: primaryZine
    }];

    if (!isLoading) {
      sections = sections.concat(
        contentSections.map((section, i) =>
          assign({
            key: stamp.id + '-' + i
          }, section)
        )
      );

      sections.push({
        key: stamp.id + '-info',
        type: SectionTypes.INFO,
        stamp: stamp,
        user: user,
        primaryZine: primaryZine,
        otherZines: _.without(zines, primaryZine),
        onOffsetTopChange: handleInfoPanelOffsetTopChange,
        showFeedback: this.props.showFeedback,
        disableInfoPanel: disableInfoPanel
      });
    }

    return {
      sections: sections
    };
  },

  componentWillReceiveProps(nextProps) {
    if (!shallowEqual(nextProps, this.props)) {
      this.setState(this.getStateFromStores(nextProps));
    }

    if (nextProps.stamp.id !== this.props.stamp.id) {
      this.resetLightbox();
    }
  },

  render() {
    var sections = this.state.sections,
        content = sections.map(this.renderSection);

    content.push(this.renderLightboxOverlay(sections));

    return (
      <div className='stamp-Stamp'>
        {_.compact(_.flatten(content))}
        {sections.length > 1 && this.props.nextUp}
      </div>
    );
  },

  renderSection(section, index, sections) {
    var fading = this.getSectionFading(index),
        props = this.getSectionProps(section, index, fading),
        ComponentType,
        component;

    ComponentType =
      SectionComponents[section.type] ||
      SectionComponents[section.type + ':' + section.layout] ||
      SectionComponents[section.type + ':' + section.mediaType + ':' + section.mediaSource];

    component = React.createElement(ComponentType, props);

    return fading ?
      this.wrapInFades(component, index, sections, fading) :
      component;
  },

  getSectionNode(index) {
    return this.refs['section-' + index].getDOMNode();
  },

  getSectionProps(section, index, fading) {
    var type = section.type,
        props;

    props = assign({
      sectionIndex: index,
      isInViewer: !!this.props.isInViewer,
      ref: 'section-' + index,
      stamp: this.props.stamp
    }, section);

    delete props.type;

    if (LightboxSections.indexOf(type) > -1) {
      assign(props, this.getLightboxProps(index));
    }

    if (type === SectionTypes.POSTER) {
      assign(props, {
        isActive: fading && fading.isActive || false
      });
    }

    return props;
  },

  getLightboxProps(index) {
    return {
      lightboxState: this.getLightboxState(index),
      getLightboxImageStyle: this.getLightboxImageStyle,
      toggleLightbox: this.toggleLightbox,
      isImageInLightbox: this.isImageInLightbox,
      onImageTransitionEnd: this.handleLightboxTransitionEnd,
      isLightboxEnabled: this.isLightboxEnabled
    };
  },

  wrapInFades(component, index, sections, fading) {
    var isLightboxVisible = this.isLightboxVisible(index),
        isInViewer = this.props.isInViewer,
        isLastContentSection = (index === sections.length - 2),
        image = sections[index].background || this.props.stamp.thumbnail || {},
        colors = image.colors || { top: 'FFFFFF', bottom: 'FFFFFF' },
        topFade,
        bottomFade;

    if (index > 0) {
      topFade = (
        <Fade key={index + '-top'}
              color={colors.top}
              isLightboxVisible={isLightboxVisible}
              isActive={fading.isActive}
              isVisible={fading.isVisible}
              opacity={fading.topOpacity}
              isTop />
      );
    }

    // Prevent last fade expanding the container beyond the last section in editor.
    if (isInViewer || isLightboxVisible || !isLastContentSection) {
      bottomFade = (
        <Fade key={index + '-bottom'}
              color={colors.bottom}
              isLightboxVisible={isLightboxVisible}
              isActive={fading.isActive}
              isVisible={fading.isVisible}
              opacity={fading.bottomOpacity} />
      );
    }

    return [topFade, component, bottomFade];
  },

  renderLightboxOverlay(sections) {
    if (!this.isFadingEnabled() || !this.getLightboxState()) {
      return;
    }

    var lightbox = this.state.lightbox.current || this.state.lightbox.previous,
        sectionIndex = lightbox.sectionIndex,
        sectionType = sections[sectionIndex].type,
        image = lightbox.image,
        colors = image.colors,
        textColor = 'dark',
        overlayColorStop;

    if (sectionType === SectionTypes.POSTER) {
      overlayColorStop = this.getGradientColorStop(
        colors,
        this.getSectionFading(sectionIndex).progress
      );
      textColor = this.getTextColor(overlayColorStop);
    } else if (sectionType === SectionTypes.COVER) {
      overlayColorStop = this.getGradientColorStop(colors, 0.5);
      textColor = this.getTextColor(overlayColorStop);
    }

    return (
      <LightboxOverlay key='overlay'
                       stamp={this.props.stamp}
                       image={image}
                       color={textColor}
                       isInLightbox={this.isInLightbox(sectionIndex)}
                       isInViewer={this.props.isInViewer}
                       hideLightbox={this.hideLightbox}
                       sectionType={sectionType} />
    );
  },

  getGradientColorStop(colors, progress) {
    var topRGB = this.parseColor(colors.top),
        bottomRGB = this.parseColor(colors.bottom);

    return _.zip(topRGB, bottomRGB).map(function (zipped) {
      var top = zipped[0],
          bottom = zipped[1],
          current = Math.round(top + (bottom - top) * progress);

      return current.toString(16);
    }).join('');
  }
});

module.exports = Stamp;



/** WEBPACK FOOTER **
 ** ./stamp/Stamp.jsx
 **/